"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _ApiClient_authentication;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const axios_1 = __importDefault(require("axios"));
const Configuration_1 = require("../Configuration");
const Error_1 = require("../Error");
const ApiError_1 = require("../model/ApiError");
const apiErrorCode_1 = require("../types/api/apiErrorCode");
class ApiClient {
    constructor(authentication) {
        _ApiClient_authentication.set(this, null);
        this.call = async (method, url, options = {}) => {
            try {
                const requestHeaders = {};
                if (this.authenticationHeader) {
                    requestHeaders[this.authenticationHeader.key] =
                        this.authenticationHeader.value;
                }
                if (options.data) {
                    requestHeaders['Content-Type'] = 'application/json';
                }
                const response = await axios_1.default.request({
                    method,
                    url,
                    data: options.data
                        ? JSON.stringify(options.data, (_, value) => typeof value === 'bigint' ? value.toString() : value)
                        : undefined,
                    headers: requestHeaders,
                    baseURL: options.baseURL ?? Configuration_1.Configuration.apiUrl,
                    timeout: options.timeout ?? 100000,
                });
                return {
                    ok: true,
                    data: response.data,
                    httpStatusCode: response.status,
                };
            }
            catch (error) {
                const axiosError = error;
                if (axiosError.response?.status) {
                    return {
                        ok: false,
                        httpStatusCode: axiosError.response.status,
                        error: ApiError_1.ApiError.from(axiosError.response.data, axiosError.response.status),
                    };
                }
                if (error instanceof Error) {
                    return {
                        ok: false,
                        httpStatusCode: 0,
                        error: ApiError_1.ApiError.from({
                            message: error.message,
                            code: apiErrorCode_1.ApiErrorCode.Unknown,
                        }, 0),
                    };
                }
                return {
                    ok: false,
                    httpStatusCode: 0,
                    error: ApiError_1.ApiError.from({
                        message: 'Unknown error',
                        code: apiErrorCode_1.ApiErrorCode.Unknown,
                    }, 0),
                };
            }
        };
        this.currentOrganization = async () => {
            if (__classPrivateFieldGet(this, _ApiClient_authentication, "f")?.organizationId) {
                return __classPrivateFieldGet(this, _ApiClient_authentication, "f").organizationId;
            }
            if (!__classPrivateFieldGet(this, _ApiClient_authentication, "f")?.accessToken) {
                throw new Error_1.KriptonioError({ message: 'access token is not set' });
            }
            const response = await this.get(`/v1/access-tokens/${__classPrivateFieldGet(this, _ApiClient_authentication, "f").accessToken}/organization`);
            if (response.ok) {
                // cache current organization
                __classPrivateFieldGet(this, _ApiClient_authentication, "f").organizationId = response.data.id;
                return response.data.id;
            }
            throw new Error_1.KriptonioError({
                message: `error while fetching organization for current access token. ${response.error.stringify()}`,
            });
        };
        this.setAuthentication = (authentication) => {
            __classPrivateFieldSet(this, _ApiClient_authentication, authentication, "f");
        };
        this.get = (url, opts = {}) => {
            return this.call('GET', url, opts);
        };
        this.post = (url, opts = {}) => {
            return this.call('POST', url, opts);
        };
        this.put = (url, opts = {}) => {
            return this.call('PUT', url, opts);
        };
        this.delete = (url, opts = {}) => {
            return this.call('DELETE', url, opts);
        };
        this.setAuthentication(authentication);
    }
    get authenticationHeader() {
        if (!__classPrivateFieldGet(this, _ApiClient_authentication, "f")) {
            return null;
        }
        if (__classPrivateFieldGet(this, _ApiClient_authentication, "f").accessToken) {
            return { key: 'X-Access-Token', value: __classPrivateFieldGet(this, _ApiClient_authentication, "f").accessToken };
        }
        if (__classPrivateFieldGet(this, _ApiClient_authentication, "f").sessionToken) {
            return {
                key: 'X-Session-Token',
                value: __classPrivateFieldGet(this, _ApiClient_authentication, "f").sessionToken,
            };
        }
        return null;
    }
}
exports.ApiClient = ApiClient;
_ApiClient_authentication = new WeakMap();
